import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../lib/theme';

/**
 * Three-state theme cycle: light → dark → system → light. Icon changes to reflect
 * the current setting; a soft halo on hover hints at the spectrum brand.
 */
export default function ThemeToggle() {
  const { theme, resolved, cycle } = useTheme();
  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
  const label = theme === 'system' ? `System (${resolved})` : theme === 'dark' ? 'Dark' : 'Light';

  return (
    <button
      onClick={cycle}
      aria-label={`Theme: ${label}. Click to cycle.`}
      title={`Theme: ${label}`}
      className="group relative grid size-9 place-items-center rounded-lg border border-border bg-surface text-body transition-all duration-200 hover:border-borderStrong hover:text-ink ring-violet-focus"
    >
      {/* hover halo using the brand spectrum */}
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 rounded-lg bg-pryma-grad opacity-0 blur-md transition-opacity duration-300 group-hover:opacity-25"
      />
      <Icon className="relative size-4 transition-transform duration-200 group-active:scale-90" />
    </button>
  );
}
